<template>
  <div class="user">
    <div class="header">
      <a class="logo" href="javascript:;"  @click="$router.push({name:'/'})">
        <img src="../assets/img/logo.svg" alt="">
      </a>
      <!-- <a class="menu_btn" href="javascript:;">
        <img src="../assets/img/menu.png" alt="">
      </a> -->
      <a class="quit" href="javascript:;" @click="loginOut">
        退出
      </a>
    </div>
    <div class="content">
      <div class="tab_box_lv1">
        <ul>
          <li>
            <a href="javascript:;" class="tab_item" @click="$router.push({name:'user'})">
              我的面板
              <i></i>
            </a>
          </li>
          <li>
            <a href="javascript:;" class="tab_item" :class="{checked:true}">
              应用管理
              <i></i>
            </a>
          </li>
        </ul>
      </div>
      <div class="report_list">
        <div class="tit">
          产业报告
          <span class="fillter"  @click="open">筛选 <i><img src="../assets/img/fillter.png" alt=""></i></span>
        </div>
        <div class="report_item" v-for="(item,index) in list" :key="index">
          <div  @click="goDetail(item,index)">
            <div class="img_box"><img :src="item.thumbWeb" alt=""><i></i></div>
            <div class="msg_box">
              <div class="msg_tit">{{item.title}}</div>
              <div class="msg_body"  style="-webkit-box-orient: vertical;">{{item.description}}</div>
            </div>
            <div class="tip_msg">
              <table cellpadding="0" border="0" width="100%">
                <tr>
                  <td align="left" width="35%"><span>作者</span> <span class="gray">{{item.createBy}}</span></td>
                  <td width="30%"><span>浏览量</span> <span class="gray">{{item.hits}}</span></td>
                  <td width="35%"><span>发布时间</span> <span class="gray">{{item.time == null ? item.time :item.time.substring(0,10)}}</span></td>
                </tr>

              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="page" v-show="list&&list.length!=0">
        <div class="page_box">
          <div class="prev">
            <img v-if="page>1" src="../assets/img/prev.png" alt="" @click="prevPage()">
            <img v-if="page==1" src="../assets/img/prev_gray.png" alt="">
          </div>
          <div class="next">
            <img v-if="page<total" src="../assets/img/next.png" alt="" @click="nextPage()">
            <img v-if="page==total" src="../assets/img/next_gray.png" alt="">
          </div>
          <div class="page_msg">
            {{page}}/{{total}}页
          </div>
        </div>
      </div>
    </div>
    <div class="model" v-show="modelShow">
      <div class="filter_box">
        <ul>
          <li>
            <a :class="{checked: isChecked == 2}" href="javascript:;"  @click="closeModel(2)">
              全部文章
            </a>
          </li>
          <li v-for="item in filterList" :key="item.id">
            <a :class="{checked: isChecked == item.id}" href="javascript:;"  @click="closeModel(item.id)">
              {{item.name}}
            </a>
          </li>
        </ul>
        <a class="filter_submit" href="javascript:;" @click="close">确定</a>
      </div>
    </div>
    <detail-footer></detail-footer>
  </div>
</template>

<script>
import DetailFooter from './_footer'

export default {
  components: {
    DetailFooter
  },
  data () {
    return {
      modelShow: false,
      list: [],
      size: 20,
      page: 1,
      total: 0, // 分页总数
      filterList: [],
      isChecked: '2' // 默认为全部文章2
    }
  },
  mounted () {
    this.getFilterList()
    this.getListByPage()
  },
  methods: {
    goDetail (item, index) {
      if (!item.url) {
        this.$router.push({name: 'industry-report-detail', query: {contentId: item.contentId, currentPage: this.page, pageSize: this.size, pagePosition: (index + 1), categoryId: this.isChecked}})
      } else {
        window.open(item.url)
      }
    },
    loginOut () {
      window.sessionStorage.removeItem('accentToken')
      this.$router.push('login')
    },
    // 获取筛选菜单
    getFilterList () {
      this.$axios.get('/api/web/phone/category/sub-list/' + this.isChecked).then(res => {
        this.filterList = res.data
      })
    },
    open () {
      this.modelShow = true
    },
    close () {
      this.modelShow = false
    },
    // 点击筛选菜单
    closeModel (num) {
      this.isChecked = num
      this.page = 1
      this.getListByPage()
    },
    prevPage () {
      window.scrollTo(0, 0)
      if (this.page > 1) {
        this.page = this.page - 1
        this.getListByPage()
      } else {
        this.page = 1
      }
    },
    nextPage () {
      window.scrollTo(0, 0)
      if (this.page < this.total) {
        this.page = this.page + 1
        this.getListByPage()
      } else {
        this.page = this.total
        this.getListByPage()
      }
    },
    getListByPage () {
      this.$axios.post('/api/web/phone/content/list-by-category', {
        categoryId: this.isChecked,
        page: this.page,
        size: this.size
      }).then((res) => {
        this.total = res.data.pages
        this.list = res.data.list
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/sass/global.scss';

  .user {
    background: #F5F5F5;
    min-height: 100vh;
    box-sizing:border-box;
    position: relative;
  }
  .pl-75{
    padding-left: 75px;
  }
  .mt-15{
    margin-top: 15px;
  }
  .header{
    height: 54px;
    background: #fff;
    border-bottom: 2px solid #f5f5f5;
    top: 0;
    left: 0;
    right: 0;
    position:fixed;
    z-index: 99;
    .logo{
      display: inline-block;
      // width: 155px;
      // height: 24px;
      position: absolute;
      top: 15px;
      left: 15px;
      img{
        height: 35px;
      }
    }
    .menu_btn{
      display: inline-block;
      position: absolute;
      top: 13px;
      right: 13px;
      width: 29px;
      height: 29px;
      img{
        width:100%;
        height:100%;
      }
    }
    .quit{
      display: inline-block;
      position: absolute;
      top: 15px;
      right: 18px;
      color: #fff;
      font-size: 16px;
    }
  }
  .tab_box_lv1{
    height: 50px;
    background: #F5F5F5;
    ul{
      padding: 0;
      margin: 0;
      width: 100%;
      display: inline-block;
    }
    ul::after{
      content: ' ';
      clear: both;
    }
    ul li{
      margin: 0;
      display: inline-block;
      width: 50%;
      float: left;
      box-sizing: border-box;
    }
    .tab_item{
      display: inline-block;
      width: 100%;
      padding: 10px 0;
      color: #999999;
      font-size:20px;
      box-sizing: border-box;
      position: relative;
      i{
        width: 100%;
        height: 2px;
        position: absolute;
        bottom: 0;
        left: 0;
        background: #E0E0E0;
      }
    }
    .tab_item.checked{
      color: #64A9FF;
      i{
        background: #64A9FF;
      }
    }

  }

  .content {
    min-height: calc(100vh - 66px);
    box-sizing: border-box;
    padding-top: 54px;
    position: relative;
    padding-bottom: 70px;
    .report_list{
      padding: 0 15px;
      text-align: left;
      .tit{
        position: relative;
        padding-right: 100px;
        height: 42px;
        line-height: 42px;
        color: #333333;
        font-size: 16px;
        border-bottom: 1px solid #E0E0E0;
        .fillter{
          position: absolute;
          right: 0;
          height: 42px;
          color: #666666;
          font-size: 14px;
          i{
            position: relative;
            width: 12px;
            height: 12px;
            img{
              width: 12px;
              height: 12px;
            }
          }
        }
      }
      .report_item{
        padding-top: 15px;
        padding-bottom: 15px;
        border-bottom: 1px solid #E0E0E0;
        position: relative;
        .img_box{
          position: absolute;
          top: 15px;
          left: 0;
          width: 94px;
          height: 68px;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .msg_box{
          min-height: 68px;
          padding-left: 120px;
          .msg_tit{
            font-size: 14px;
            color: #333333;
            height:20px;
            line-height:20px;
            margin-bottom: 12px;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .msg_body{
            height:36px;
            font-size:13px;
            color: #666666;
            line-height:18px;
            overflow:hidden;
            text-overflow:ellipsis;
            display:-webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
        }
        .tip_msg{
          td{
            height: 22px;
            font-size: 10px;
          }
          margin-top: 15px;
          span{
            display: inline-block;
            max-width: 65px;
            white-space: nowrap;
            overflow: hidden;
            position: relative;
            height: 20px;
          }
          span.gray{
            color: #999999;
          }
        }
      }
    }
    .page{
      padding: 25px;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      .page_box{
        position: relative;
        margin: 0 auto;
        width: 112px;
        color: #666666;
        font-size: 14px;
        .prev{
          position: absolute;
          left: 0;
          top: 2px;
          width: 16px;
          height: 16px;
        }
        .next{
          position: absolute;
          right:0;
          top: 2px;
          width: 16px;
          height: 16px;
        }
        img{
          width: 16px;
          height: 16px;
          content:normal !important;
        }
      }
    }
  }

  .model {
    position: fixed;
    z-index: 999;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background:rgba(0,0,0,0.3);
    width: 100%;
    height: 100vh;
    .filter_box{
      background: #fff;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      box-sizing: border-box;
      padding: 50px 24px 100px 27px;
    }
    ul{
      width: 260px;
      overflow:hidden;

      li{
        width: calc(50% - 8px);
        margin-bottom: 16px;
        float: left;
      }
      li:nth-child(odd){
        margin-right: 16px;
      }
      a{
        color:#333333;
        width: 100%;
        height: 100%;
        display: inline-block;
        text-align: center;
        border-radius:3px;
        background: #EBEBEB;
        color: #333333;
        height: 44px;
        line-height: 44px;
        font-size: 14px;
      }
      a.checked{
        color:#64A9FF;
        background: #DAEBFF;
      }
    }
    .filter_submit{
      position: absolute;
      bottom: 100px;
      left: 30px;
      right: 30px;
      height:31px;
      line-height:31px;
      background:#64A9FF;
      border-radius:5px;
      font-size: 18px;
      color: #fff;
    }
  }
  .footer{
    box-sizing: border-box;
    height: 66px;
    background: #0C324C;
    padding: 12px 0;
    li{
      color: #fff;
      font-size: 13px;
      height: 18px;
      span{
        width:6px;
        display: inline-block;
        text-align: center;
      }
      a{
        color: #fff;
      }
    }
    .footer_tip{
      margin-top: 7px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/industry-report.vue